export const history = [
  { year: '1992', title: 'Kuruluş', text: "Plaza Turizm'in kuruluşu ve kurumsal seyahat yolculuğunun başlangıcı." },
  { year: '1997', title: 'İlk Büyük Kongreler', text: 'İlk büyük ulusal kongre organizasyonları.' },
  { year: '2002', title: 'Milli Takım Operasyonu', text: 'Türkiye Futbol Federasyonu ve Milli Takım Dünya Kupası seyahat operasyonları.' },
  { year: '2005', title: 'UEFA Şampiyonlar Ligi Finali', text: 'UEFA Şampiyonlar Ligi Final organizasyonu.' },
  { year: '2008', title: 'Avrupa Şampiyonası', text: 'Avrupa Şampiyonası organizasyon deneyimi.' },
  { year: '2011', title: 'Uluslararası Kongreler', text: 'Binlerce katılımcılı uluslararası kongreler.' },
  { year: '2012', title: 'Ödüller', text: 'Kongre organizasyonu alanındaki ödüller.' },
  { year: '2018', title: 'Global İş Birlikleri', text: 'Uluslararası seyahat yönetimi iş birliklerinde yeni dönem.' },
  { year: 'BUGÜN', title: 'Geleceğin Altyapısı', text: 'Geçmişimizi sergilemiyoruz. Geleceğin altyapısına dönüştürüyoruz.' }
];

export const pillars = ['İnsan', 'Teknoloji', 'Operasyon', 'Veri', 'Güven'];

export const ctmPillars = [
  { t: 'Doğru Satın Alma', b: 'Seyahat alternatiflerini şirket ihtiyaçları doğrultusunda değerlendirmek.' },
  { t: 'Raporlanabilirlik', b: 'Rezervasyon ve operasyon verisini karar alınabilir hale getirmek.' },
  { t: 'Finansal Takip', b: 'Fatura ve işlem süreçlerini daha görünür hale getirmek.' },
  { t: 'Süreklilik', b: 'Seyahat öncesinde, sırasında ve sonrasında operasyon desteği.' },
  { t: 'Kuruma Uyum', b: 'Her şirketin yapısına ve seyahat politikasına göre şekillenen süreç.' },
  { t: 'İnsan Desteği', b: 'Teknolojinin yanında ihtiyaç anında uzman ekip.' }
];

export const flowSteps = [
  { n: '01', t: 'Talep Alındı', d: 'Kurumsal seyahat talebi Plaza Flow\u2019a ulaşır ve anında kayıt altına alınır.' },
  { n: '02', t: 'Yapay Zeka Analizi', d: 'Talep yapay zekâ ile analiz edilir, saniyeler içinde doğru departman ve uzman ekibe yönlendirilir.' },
  { n: '03', t: 'Operasyon Yönetimi', d: 'En uygun seçenekleri kurumsal seyahat politikanız doğrultusunda, hızlı ve şeffaf şekilde sunarız.' },
  { n: '04', t: 'Anlık Süreç Görünürlüğü', d: 'Talebin durumu ve operasyon akışı uçtan uca görünür hale gelir.' },
  { n: '05', t: 'SLA & Hizmet Kalitesi', d: 'İşlem süreleri anlık takip edilir ve en hızlı hizmet verilerek sürdürülebilir hale gelir.' },
  { n: '06', t: 'Raporlama & İçgörü', d: 'Operasyon verileri ölçülebilir raporlara dönüşür; performans veriye dayalı izlenir.' }
];

export const dashboardWidgets = [
  { label: 'Talepler', value: '—', hint: 'Aktif dönem' },
  { label: 'Aktif Operasyonlar', value: '—', hint: 'An lık' },
  { label: 'SLA', value: '—', hint: 'Hedef uyumu' },
  { label: 'Harcama', value: '—', hint: 'Departman bazı' },
  { label: 'Faturalar', value: '—', hint: 'Dönemsel' },
  { label: 'Rezervasyon Türleri', value: '—', hint: 'Dağılım' }
];

export const complexityChips = ['Uçuş','Otel','Vize','Transfer','Araç','Seyahat Politikası','Onay','Fatura','Finans','Raporlama','7/24 Destek','Organizasyon'];

export const finalWords = ['UÇUŞ','OTEL','TRANSFER','ARAÇ','VİZE','EVENT','TEKNOLOJİ','FİNANS','RAPORLAMA','İNSAN','GLOBAL'];
